import Image from 'next/image';
import React from 'react';

const companies = [
  {
    name: 'ByteDance',
    logo: 'https://assets.getcreatr.com/sign-up/bytedance.svg',
    url: 'https://www.bytedance.com',
    width: 118,
  },
  {
    name: 'Accel',
    logo: 'https://assets.getcreatr.com/sign-up/accel.svg',
    url: 'https://www.accel.com',
    width: 80,
  },
  {
    name: 'Deloitte',
    logo: 'https://assets.getcreatr.com/sign-up/delloite.svg',
    url: 'https://www.deloitte.com',
    width: 80,
  },
  {
    name: 'Convex',
    logo: 'https://assets.getcreatr.com/sign-up/convex.svg',
    url: 'https://www.convex.dev',
    width: 80,
  },
  {
    name: 'Vercel',
    logo: 'https://assets.getcreatr.com/sign-up/vercel.svg',
    url: 'https://www.vercel.com',
    width: 80,
  },
  {
    name: 'Google',
    logo: 'https://assets.getcreatr.com/sign-up/google.svg',
    url: 'https://www.google.com',
    width: 100,
  },
];

function NewEraSoftware() {
  return (
    <div className="w-full h-full relative rounded-lg overflow-hidden">
      <Image
        src="https://assets.getcreatr.com/sign-up/new-era.jpg"
        alt="Sign Up"
        className="object-cover w-full h-[calc(100vh-48px)]"
        height={500}
        width={500}
      />
      <div className="absolute h-full w-full inset-0 flex flex-col justify-end mx-auto max-w-2xl px-4 2xl:max-w-3xl">
        <p className="font-semibold text-6xl 2xl:text-7xl mb-15 leading-[1.2]">
          The new era of building software
        </p>
        {/* Companies Section */}
        <div className="flex w-full flex-wrap mb-8 justify-between gap-3 mb-30">
          {companies.map((company, index) => (
            <div className="h-5" key={index}>
              <Image
                src={company.logo}
                alt={company.name}
                className="object-contain w-full h-full"
                width={company.width}
                height={60}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NewEraSoftware;
